module.exports = __webpack_public_path__ + "img/new-guest.033c3491.svg";